<template>
  <div class="join-us">
    <nav-header :activeIndex="5" />
    <header class="join-us-header">
      <div class="dialog"></div>
      <img src="../../assets/banner/pic-join-us.png" alt="">
      <div class="banner-inner">
        <p class="banner-inner-title">加入「圣诉」</p>
        <p class="banner-inner-content">迄今已有600多位律师加入圣诉平台</p>
        <p class="banner-inner-content">用专业的法律服务打造优质法律服务的新标准</p>
      </div>
    </header>
    <main class="join-us-main">
      <div class="join-us-main-inner">
        <div v-if="showUser" class="join-us-main-inner-lawyer">
          <div class="join-us-main-inner-lawyer-item">
            <b>姓名 *</b>
            <div class="verification">
              <input type="text" v-model="formData.lawyerName" @blur="lawyerNameRex"/>
              <p v-if="lawyerNameShow" class="verification-txt">请填写正确的姓名</p>
            </div>
          </div>
          <div class="join-us-main-inner-lawyer-item">
            <b>执业证号 *</b>
            <div class="verification">
              <input type="text" v-model="formData.practiceAccount" @blur="practiceAccountRex"/>
              <p v-if="practiceAccountShow" class="verification-txt">请填写正确的执业证号</p>
            </div>
          </div>
          <div class="join-us-main-inner-lawyer-item">
            <b>联系方式 *</b>
            <div class="verification">
              <input type="text" v-model="formData.lawyerPhone" @blur="lawyerPhoneRex"/>
              <p v-if="lawyerPhoneShow" class="verification-txt">请填写正确的手机号</p>
            </div>
          </div>
          <div class="join-us-main-inner-lawyer-item">
            <b>律所名称 *</b>
            <div class="verification">
              <input type="text" v-model="formData.lawfirm" @blur="lawfirmRex"/>
              <p v-if="lawfirmShow" class="verification-txt">请填写正确的律所名称</p>
            </div>
          </div>
          <div class="join-us-main-inner-lawyer-item">
            <b>地址 *</b>
            <div class="address">
              <el-dropdown trigger="click" class="select-input-province" @command="selectProvince">
                <span class="el-dropdown-link">
                   {{formData.province || '省'}}
                </span>
                <el-dropdown-menu slot="dropdown" style="height: 300px;overflow-y: scroll;">
                  <el-dropdown-item v-for="(item, index) in provinceList" :key="index"
                          :command="item.name"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown trigger="click" class="select-input" @command="selectCity">
                <span class="el-dropdown-link">
                  {{formData.city || '市'}}
                </span>
                <el-dropdown-menu slot="dropdown" style="height: 300px;overflow-y: scroll;">
                  <el-dropdown-item v-for="(item, index) in cityList" :key="index"
                                    :command="item.name"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <div v-else class="join-us-main-inner-lawyer">
          <div class="join-us-main-inner-lawyer-item">
            <b>姓名 *</b>
            <div class="verification">
              <input type="text" v-model="formData.lawyerName" @blur="lawyerNameRex"/>
              <p class="verification-txt" v-if="lawyerNameShow">请填写正确的姓名</p>
            </div>
          </div>
          <div class="join-us-main-inner-lawyer-item">
            <b>联系方式 *</b>
            <div class="verification">
              <input type="text" v-model="formData.lawyerPhone" @blur="lawyerPhoneRex"/>
              <p class="verification-txt" v-if="lawyerPhoneShow">请填写正确的手机号</p>
            </div>
          </div>
          <div class="join-us-main-inner-lawyer-item">
            <b>地址 *</b>
            <div class="address">
              <el-dropdown trigger="click" class="select-input-province" @command="selectProvince">
                <span class="el-dropdown-link">
                  {{formData.province || '省'}}
                </span>
                <el-dropdown-menu slot="dropdown" style="height: 300px;overflow-y: scroll;">
                  <el-dropdown-item v-for="(item, index) in provinceList" :key="index"
                                    :command="item.name"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown trigger="click" class="select-input" @command="selectCity">
                <span class="el-dropdown-link">
                  {{formData.city || '市'}}
                </span>
                <el-dropdown-menu slot="dropdown" style="max-height: 300px;overflow-y: scroll;">
                  <el-dropdown-item v-for="(item, index) in cityList" :key="index"
                                    :command="item.name"
                  >{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="concat-us" @click="saveLawyer">
        {{showUser === 'user' ? '加入圣诉' : '联系圣诉'}}
      </div>
      <div class="concat-msg">稍后会有工作人员在24小时内联系您，请保持通话</div>
    </main>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>您的信息已提交成功！稍后会有工作人员在24小时内联系您，请保持通话</span>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
  import api from './api'
  import { Message } from 'element-ui/lib'
  import NavHeader from '@/common-components/nav-header'
  export default {
    name: 'join-us',
    components: { NavHeader },
    data () {
      return {
        dialogVisible: false,
        showUser: false,
        provinceList: [],
        cityList: [],
        formData: {
          lawyerName: '',
          practiceAccount: '',
          lawyerPhone: '',
          lawyerAddress: '',
          city: '',
          province: '',
          lawfirm: ''
        },
        lawyerNameShow: false,
        lawyerPhoneShow: false,
        lawfirmShow: false,
        practiceAccountShow: false
      }
    },
    mounted () {
      if (this.$route.query.type === 'user') {
        this.showUser = false
      } else {
        this.showUser = true
      }
      this.getProvinceList()
    },
    methods: {
      // 获取省份接口
      async getProvinceList () {
        let res = await api.getProvinceList()
        if (res.data.isSuccess) {
          this.provinceList = res.data.data
        } else {
          Message.error(res.data.resultMsg)
        }
      },
      async selectProvince (value) {
        this.formData.province = value
        let res = await api.getCity(value)
        if (res.data.isSuccess) {
          this.cityList = res.data.data
          this.formData.city = ''
        } else {
          Message.error(res.data.resultMsg)
        }
      },
      selectCity (value) {
        this.formData.city = value
      },
      // 律师姓名校验
      lawyerNameRex () {
        let reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/
        if (!reg.test(this.formData.lawyerName)) {
          this.lawyerNameShow = true
        } else {
          this.lawyerNameShow = false
        }
      },
      lawfirmRex () {
        let reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/
        if (!reg.test(this.formData.lawfirm)) {
          this.lawfirmShow = true
        } else {
          this.lawfirmShow = false
        }
      },
      // 手机号校验
      lawyerPhoneRex () {
        let reg = /^((0\d{2,3}-\d{7,8})|(1[3-9]\d{9}))$/
        if (!reg.test(this.formData.lawyerPhone)) {
          this.lawyerPhoneShow = true
        } else {
          this.lawyerPhoneShow = false
        }
      },
      // 执业证号校验
      practiceAccountRex () {
        let reg = /^([0-9]\d{16})$/
        if (!reg.test(this.formData.practiceAccount)) {
          this.practiceAccountShow = true
        } else {
          this.practiceAccountShow = false
        }
      },
      // 保存信息
      async saveLawyer () {
        // let id = ''
        // if (process.env.NODE_ENV === 'development') {
        //   id = 12
        // } else if (process.env.NODE_ENV === 'production') {
        //   id = 19
        // } else {
        //   id = 11
        // }
        let res = ''
        if (this.lawyerNameShow || !this.formData.lawyerName) {
          return false
        }
        if (this.lawyerPhoneShow || !this.formData.lawyerPhone) {
          return false
        }
        if (!this.formData.province || !this.formData.city) {
          return false
        }
        if (this.$route.query.type === 'user') {
          let obj = {
            id: 432,
            name: this.formData.lawyerName,
            phone: this.formData.lawyerPhone,
            remark: this.formData.province + '-' + this.formData.city,
            origin: '3030'
          }
          res = await api.saveLawyer(obj, 'user')
        } else {
          if (this.lawfirmShow || !this.formData.lawfirm) {
            return false
          }
          if (this.practiceAccountShow || !this.formData.practiceAccount) {
            return false
          }
          let obj = {
            city: this.formData.city,
            province: this.formData.province,
            lawyerName: this.formData.lawyerName,
            lawyerPhone: this.formData.lawyerPhone,
            lawyerGender: 3,
            practiceAccount: this.formData.practiceAccount,
            lawfirm: this.formData.lawfirm
          }
          res = await api.saveLawyer(obj, 'lawyer')
        }
        if (res.data.isSuccess) {
          this.formData = {
            lawyerName: '',
            practiceAccount: '',
            lawyerPhone: '',
            lawyerAddress: '',
            city: '',
            province: '',
            lawfirm: ''
          }
          this.dialogVisible = true
          setTimeout(() => {
            this.dialogVisible = false
          }, 5000)
        } else {
          Message.error(res.data.resultMsg)
        }
      }
    }
  }
</script>

<style lang='stylus' scoped>
  @import '../../styles/constant.styl'
  .join-us {
    &-header {
      width: 100%
      height: 5rem
      background #000
      img {
        width: 100%
        height: 100%
      }
      .dialog {
        width: 100%
        height: 5rem
        background #000
        position absolute
        top 0
        left 0
        opacity .5
      }
      .banner-inner {
        color: #fff
        position absolute
        top 2.20rem
        left 2.52rem
        &-title {
          font-size: .6rem;
          font-weight: 6rem;
        }
        &-content {
          margin .08rem 0 .08rem 0
          font-size: .36rem
          font-weight: 300
        }
      }
    }
    &-main {
      width: 100%
      background #f7f7f7
      padding .64rem .8rem .48rem .8rem
      &-inner {
        width: 6.2rem
        margin 0 auto
        padding .4rem .3rem
        background #fff
        &-lawyer {
          margin 0 auto
          &-item {
            display flex
            justify-content space-between
            height .48rem
            line-height .48rem
            margin-bottom .4rem
            b {
              font-size: .18rem;
              font-weight: 500;
              color: #1d1b1b;
            }
            input {
              width: 4.55rem
              height: .48rem
              border-radius: .04rem
              background-color: #f5f5f5;
              padding 0 .1rem
              font-size: .18rem
            }
            .verification {
              width: 4.55rem
              position relative
              .verification-txt {
                width: 100%
                position absolute
                top .43rem
                color red
                left .1rem
              }
            }
            .address {
              width: 4.55rem
              display flex
            }
            .select-input-province {
              min-width: 1.7rem;
              background #f5f5f5
              border-radius: .04rem
              padding 0 .1rem
              flex 1
              input {
                outline none
                padding 0 .1rem
              }
              .el-dropdown-link.el-dropdown-selfdefine {
                width: 100%
                font-size .18rem
                display inline-block
                text-align right
                color #959595
                font-weight: 500
                padding 0 .2rem
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
              }
            }
            .select-input {
              background #f5f5f5
              border-radius: .04rem
              margin-left .2rem
              padding 0 .1rem
              flex 1
              input {
                outline none
                padding 0 .1rem
              }
              .el-dropdown-link.el-dropdown-selfdefine {
                width: 100%
                font-size: .18rem
                display inline-block
                text-align right
                color: #959595;
                font-weight: 500
                padding-right .2rem
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
              }
            }
          }
          &-item:last-child {
            margin-bottom 0
          }
        }
      }
      .concat-us {
        width: 4.6rem
        height: .64rem
        background-color: #ed6c00;
        color: #fff
        text-align center
        line-height .64rem
        font-size: .24rem
        font-weight: 500
        margin .64rem auto 0
        cursor pointer
      }
      .concat-msg {
        text-align center
        color: #a9a9a9;
        font-size: .14rem
        margin-top .16rem
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/join-us-detail/join-us-detail.vue